import { UserService } from "./userServiceModel";

export class UserSkillsGridModel {
    userId: number = 0;
    optIn: boolean = false;
    serviceId: number = 0;
    serviceName: string = '';
    categoryId: number = 0;
    categoryName: string = '';
    proficiency: number = 0;
    isProficiencyInvalid: boolean = false;
}
